import React from "react";
import { Trans, useTranslation } from "react-i18next";

import badgeDefault from "../../../assets/images/icons/badge-default.svg";
import { colors } from "../../../styles/variables";
import { I18N_NAMESPACES } from "../../../helpers/constants";
import { getChallengeBadgePoints } from "../../../helpers/tools";
import { ChallengeBadges_memberBadgesByCategory } from "../../../types/__generated__/ChallengeBadges";

import ImageAndTextListCell from "../ImageAndTextListCell";

import {
  ChallengeBadgeImage,
  ChallengeBadgeImageBackground,
  ChallengeDescriptionTableContainer,
  ChallengeDescriptionTableImageWrapper,
  ChallengeDescriptionTableText,
  ChallengeDescriptionTitle,
  DiscoverImage,
} from "./style";

interface ChallengeDescriptionPointsProps {
  shouldShowTitle?: boolean;
  challengeBadge: ChallengeBadges_memberBadgesByCategory | null | undefined;
}

const ChallengeDescriptionPoints = ({
  shouldShowTitle = false,
  challengeBadge,
}: ChallengeDescriptionPointsProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.MY_BADGES, I18N_NAMESPACES.MY_DASHBOARD]);

  const earnPointsImage = (
    <ChallengeDescriptionTableImageWrapper>
      <ChallengeBadgeImageBackground>
        <ChallengeBadgeImage src={challengeBadge?.imageSmallUrl ?? badgeDefault} />
      </ChallengeBadgeImageBackground>
    </ChallengeDescriptionTableImageWrapper>
  );
  const earnPointsText = (
    <ChallengeDescriptionTableText>
      <Trans
        i18nKey="myBadges:challengeDescription.earnPoints"
        count={getChallengeBadgePoints(challengeBadge || {})}
        components={{ bold: <strong /> }}
      />
    </ChallengeDescriptionTableText>
  );

  const discoverImage = (
    <ChallengeDescriptionTableImageWrapper>
      <DiscoverImage />
    </ChallengeDescriptionTableImageWrapper>
  );

  const discover = (
    <ChallengeDescriptionTableText>
      {challengeBadge?.challengeKeyBenefit ??
        t("myBadges:challengeDescription.discover", {
          name: challengeBadge?.name ?? "",
        })}
    </ChallengeDescriptionTableText>
  );

  return (
    <>
      {shouldShowTitle && (
        <ChallengeDescriptionTitle>{t("myBadges:challengeDescription.title")}</ChallengeDescriptionTitle>
      )}
      <ChallengeDescriptionTableContainer>
        <ImageAndTextListCell
          imageComponent={earnPointsImage}
          textComponent={earnPointsText}
          bgColor={colors.peachTint}
        />
        <ImageAndTextListCell
          imageComponent={discoverImage}
          textComponent={discover}
          bgColor={colors.peachTint}
        />
      </ChallengeDescriptionTableContainer>
    </>
  );
};

export default ChallengeDescriptionPoints;
